import { Dictionary } from "cayo.ui";
import {
  FilterItem,
  ConditionType,
  IModernFilterCondition,
  IQuery,
} from "@cayo/shared/components/GridContainer/types";
import { objectUtils } from "@cayo/shared/utils/object";

export const convertFilterItemsToObject = (items: FilterItem[]): Dictionary => {
  const result: Dictionary = {};
  items.forEach((i) => (result[i.name] = i.value));
  return result;
};

export const getFilterItems = (query?: IQuery) => {
  const items = (
    query?.conditions.find((c) => c.kind === ConditionType.ModernFilter) as IModernFilterCondition
  )?.value;

  const result = items?.length ? objectUtils.cloneObject(items as FilterItem[]) : [];
  return result;
};
